import { get } from 'lodash';
import type { ColumnType, SortOrder } from 'antd/es/table/interface';

// Shared date policy: newest first. Each table chooses its default date explicitly.
const dateSortDirections: SortOrder[] = ['descend', 'ascend'];

export function serverDateSort(isDefault = false) {
  return {
    sorter: true,
    sortDirections: dateSortDirections,
    ...(isDefault ? { defaultSortOrder: 'descend' as const } : {}),
  };
}

export function localDateSort(
  field: string | string[],
  isDefault = false,
): Pick<ColumnType<any>, 'sorter' | 'sortDirections' | 'defaultSortOrder'> {
  return {
    ...serverDateSort(isDefault),
    sorter: (a, b) => {
      const timestamp = (record: any) => {
        const value = get(record, field);
        const time = value ? new Date(value).getTime() : NaN;
        return Number.isFinite(time) ? time : -Infinity;
      };
      const first = timestamp(a);
      const second = timestamp(b);
      return first === second ? 0 : first < second ? -1 : 1;
    },
  };
}
